/*
 * Jira Ticket:
 * Created Date: Tue, 29th Oct 2019, 12:06:33 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2019 The Distance
 */

import * as R from 'ramda';
import { NEXT_CURSOR } from './actions';
import * as _ from 'lodash';

// add custom reducers here

const ofNull = [null];

// appendOrUpdate :: Number -> a -> [a] -> [a]
const appendOrUpdate = R.curry((idx, x, xs) =>
  idx in xs ? R.update(idx, x, xs) : R.append(x, xs)
);

const locationChange = (prevState, payload, resource) => {
  var regex = new RegExp('^/' + resource);
  if (payload.location && regex.test(payload.location.pathname)) {
    return prevState;
  }
  return ofNull;
};

// nextCursor :: ([a], Object) -> [a]
const nextCursor = (prevState, action) =>
  R.apply(
    R.partialRight(appendOrUpdate, [prevState]),
    R.props(['page', 'cursor'], action)
  );

const actions = {
  '@@router/LOCATION_CHANGE': locationChange,
  [NEXT_CURSOR]: nextCursor,
};

export const paginationReducerFactory = resource => (
  prevState = ofNull,
  { type, payload }
) => (actions[type] ? actions[type](prevState, payload, resource) : prevState);

export const setTabbedFilterFieldReducer = (state = {}, action) => {
  switch (action.type) {
    case 'APP/SET_FILTER':
      const prevState = Object.assign({}, state[action.tab]);
      const combined = _.defaults(action.data, prevState); // merge our specific resource filters
      const cleaned = _.pickBy(combined, _.identity); // remove all falsey values
      return { ...state, [action.tab]: cleaned }; // return the new merged filters
    case 'APP/CLEAR_FILTERS':
      const removedTabFilter = Object.assign({}, state);
      delete removedTabFilter[action.tab];
      return { ...removedTabFilter };
    default:
      return state;
  }
};
